module.exports = __webpack_public_path__ + "img/identityChecked.ce9a28d4.png";